module.exports = __webpack_public_path__ + "img/balkon12.c617a7d2.webp";